import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAuthenticatedUser,
  selectGlobalSetting,
} from 'app/slice/selectors';
import { AllowedSettings } from 'utils/globalSettings';
import { Roles } from 'app/slice/types';
import { tryParseInt } from 'utils/string-utils';
import { dateUtils } from 'utils/date-utils';
import { useSystemDate } from 'app/hooks/useSystemDate';
import { schedulerActions } from '../slice';
import { DetectIsMobile } from 'utils/mobileDetect';

export const useRefreshInterval = () => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(selectAuthenticatedUser);
  const intervalRefreshingCalendar = useSelector(state =>
    selectGlobalSetting(state, AllowedSettings.IntervalRefreshingCalendar),
  );
  const calendarOnly = authenticatedUser?.Roles?.includes(Roles.CalendarOnly);
  const { newDate } = useSystemDate();
  const isMobile = DetectIsMobile();
  const DEFAULT_REFRESH_INTERVAL_MINUTES = 2;
  const MAX_REFRESH_INTERVAL_MINUTES = 120;
  const MILLISECONDS_IN_MINUTE = 60000;

  const configuredRefreshInterval = React.useMemo(() => {
    return (
      tryParseInt(intervalRefreshingCalendar) ??
      DEFAULT_REFRESH_INTERVAL_MINUTES
    );
  }, [intervalRefreshingCalendar]);

  const refreshIntervalNumber = React.useMemo(() => {
    return configuredRefreshInterval < DEFAULT_REFRESH_INTERVAL_MINUTES ||
      configuredRefreshInterval > MAX_REFRESH_INTERVAL_MINUTES
      ? DEFAULT_REFRESH_INTERVAL_MINUTES
      : configuredRefreshInterval;
  }, [configuredRefreshInterval]);
  const refreshInterval = React.useCallback(() => {
    try {
      const date = dateUtils.formatISO(newDate());
      dispatch(schedulerActions.setDate(date));
    } catch (error) {
      console.error(error);
    }
  }, [dispatch, newDate]);
  React.useEffect(() => {
    let handle = 0;

    if (calendarOnly === true && !isMobile) {
      handle = setInterval(
        refreshInterval,
        refreshIntervalNumber * MILLISECONDS_IN_MINUTE,
      );
    }

    return () => clearInterval(handle);
  }, [calendarOnly, isMobile, refreshInterval, refreshIntervalNumber]);
  return { refreshInterval };
};
